import { FC } from 'react'

import { GreyGrey60, IconBubbleDots } from '@sequencehq/core-components'

export const NoteIcon: FC = () => <IconBubbleDots color={GreyGrey60} />
